import { render, staticRenderFns } from "./traditionalForm.vue?vue&type=template&id=66eeadb2"
import script from "./traditionalForm.vue?vue&type=script&lang=js"
export * from "./traditionalForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports